import { z } from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/graphql/constants'
import { validateAdUnitSizes } from '../../utils'

export const viewportSchema = z.object({
  bannerEnabled: z.boolean(),
  bannerSizes: z.string().array().superRefine(validateAdUnitSizes),
  minimumWidth: z.number().min(0).max(MAX_SAFE_GQL_INTEGER),
  name: z.string().min(1),
  nativeEnabled: z.boolean(),
  playerSize: z.string().array().superRefine(validateAdUnitSizes),
  videoEnabled: z.boolean(),
  viewportId: z.string().optional(),
})

export const schema = z.object({
  viewports: viewportSchema.array(),
})

export type Schema = z.infer<typeof schema>
export type ViewportSchema = z.infer<typeof viewportSchema>

export const defaultViewportSchema: ViewportSchema = {
  bannerEnabled: false,
  bannerSizes: [],
  minimumWidth: 0,
  name: '',
  nativeEnabled: false,
  playerSize: [],
  videoEnabled: false,
  viewportId: '',
}

export const defaultSchema = (): Schema => ({ viewports: [] })
